/**
 * Checks whether the current environment is set to "development".
 *
 * This is determined by inspecting the `NODE_ENV` environment variable.
 * Commonly used to enable development-specific features like debugging tools or verbose logging.
 *
 * @returns `true` if `process.env.NODE_ENV` is `"development"`, otherwise `false`.
 */
export const isDevMode = (): boolean => process.env.NODE_ENV === "development";

/**
 * Checks whether the current environment is set to "production".
 *
 * This is useful for enabling production-only features like optimizations or error tracking.
 *
 * @returns `true` if `process.env.NODE_ENV` is `"production"`, otherwise `false`.
 */
export const isProdMode = (): boolean => process.env.NODE_ENV === "production";
